var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThailand = function SvgThailand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8 4.667A9.928 9.928 0 0 0 12 2C9.367 2 7 3 5.2 4.667h13.6ZM5.2 19.333A9.928 9.928 0 0 0 12 22c2.633 0 5-1 6.8-2.667H5.2Z",
    fill: "#ED4C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12c0 1.433.3 2.767.833 4h18.334A9.99 9.99 0 0 0 22 12a9.99 9.99 0 0 0-.833-4H2.833A9.989 9.989 0 0 0 2 12Z",
    fill: "#2A5F9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 19.334h13.567c1-.934 1.833-2.067 2.366-3.334H2.8c.6 1.267 1.4 2.4 2.4 3.334ZM18.8 4.667H5.2C4.2 5.6 3.367 6.733 2.833 8h18.334A10.298 10.298 0 0 0 18.8 4.667Z",
    fill: "#F9F9F9"
  })));
};
export default SvgThailand;